class SwiperElement extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    const swiperEl = this.querySelector(".swiper");
    if (!swiperEl || typeof Swiper === "undefined") return;

    const options = {
      slidesPerView: this.numberAttr("slides-per-view", 1),
      spaceBetween: this.numberAttr("space-between", 0),
      centeredSlides: this.hasAttribute("centered"),
      loop: this.hasAttribute("loop"),
      initialSlide: this.numberAttr("initial-slide", 0),
      slideToClickedSlide: this.hasAttribute("clicked-to-slide"),
      speed: this.numberAttr("speed", 300),
    };

    console.log("SWIPER INITIALIZED");

    // Navigation
    const next = this.getAttribute("next");
    const prev = this.getAttribute("prev");

    if (next && prev) {
      options.navigation = {
        nextEl: this.querySelector(next),
        prevEl: this.querySelector(prev),
      };
    }

    // Pagination
    const pagination = this.getAttribute("pagination");

    if (pagination) {
      options.pagination = {
        el: this.querySelector(pagination),
        clickable: true,
      };
    }

    // Breakpoints (JSON)
    const breakpoints = this.getAttribute("breakpoints");

    if (breakpoints) {
      try {
        options.breakpoints = JSON.parse(breakpoints);
      } catch (e) {
        console.warn("Invalid Swiper breakpoints JSON", e);
      }
    }

    this.swiper = new Swiper(swiperEl, options);
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  numberAttr(name, fallback) {
    const value = this.getAttribute(name);
    return value !== null ? Number(value) : fallback;
  }
}

customElements.define("swiper-element", SwiperElement);